import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero.jsx';
import PlatformBanner from '../components/PlatformBanner.jsx';
import FeatureCards from '../components/FeatureCards.jsx';
import InfoStrip from '../components/InfoStrip.jsx';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const targetId = location.state && location.state.scrollTo;
    if (targetId) {
      const el = document.getElementById(targetId);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50);
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <PlatformBanner />
      <FeatureCards />
      <InfoStrip />
    </>
  );
}